<template>
    <div>
        <v-row justify="center">
            <v-col cols="12" sm="12">
                <v-card class="px-5 px-md-13 px-sm-7 px-lg-16 py-5 py-md-8 py-sm-5 py-lg-10">
                    <v-row>
                        <v-col cols="12">
                            <header-big :title="$t('RevokePage.title')" />
                        </v-col>
                    </v-row>
                    <v-row v-if="!checked">
                        <v-card-text>
                            <div>
                                <p v-text="$t('RedirectQES.Message_a')" class="text-center mb-0" />
                            </div>
                            <div>
                                <p v-text="$t('RedirectQES.Message_b')" class="text-center mb-0" />
                            </div>
                            <v-col class="
                              button__full
                              d-flex
                              justify-xs-center
                              justify-sm-center
                              justify-md-center
                              justify-lg-center
                            ">
                                <div class="half-circle-spinner">
                                    <div class="circle circle-1"></div>
                                    <div class="circle circle-2"></div>
                                </div>
                            </v-col>
                        </v-card-text>
                    </v-row>
                    <v-row v-if="checked">
                        <v-card-text>
                            <div v-if="success">
                                <strong>
                                    <p v-text="$t('RedirectQES.checked')" class="text-center mb-0" />
                                </strong>
                            </div>
                            <div v-if="!success">
                                <p v-text="$t('RedirectQES.wrong')" class="text-center mb-0" />
                            </div>
                            <v-form v-if="resetPassword && success" ref="form">
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-text-field filled v-model="password" :label="$t('ResetPage.new_password')"
                                            :append-icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="() => (showNewPassword = !showNewPassword)"
                                            :type="showNewPassword ? 'text' : 'password'"
                                            :rules="rules.password"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-text-field filled :rules="rules.passwordConfirmationRules"
                                            v-model="confirmPassword" :append-icon="
                                                showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'
                                            " :type="showConfirmPassword ? 'text' : 'password'" name="input-10-1"
                                            :label="$t('repeat_password')" @click:append="
                                                showConfirmPassword = !showConfirmPassword
                                            " dense></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="12" class="text-right">
                                        <custom-button :text="$t('Headers.save')" @click="changePassword"></custom-button>
                                    </v-col>
                                </v-row>
                            </v-form>
                            <v-col cols="12" sm="12" class="text-right">
                                <custom-button v-if="!success && !resetPassword" :text="$t('RevokePage.redirect')"
                                    @click="redirect"></custom-button>
                            </v-col>
                            <v-col cols="12" sm="12" class="text-right">
                                <custom-button v-if="success && !resetPassword" :text="$t('RevokePage.next')"
                                    @click="next"></custom-button>
                            </v-col>
                        </v-card-text>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>

import i18n from "@/i18n";
import HeaderBig from "../../components/ui/text/HeaderBig.vue";
import HeaderMedium from "../../components/ui/text/HeaderMedium.vue";
import CustomButton from "../../components/ui/input/CustomButton.vue";
import BaseTimer from "../../components/ui/other/BaseTimer.vue";
import cookie from "vue-cookies";

export default {
    name: "redirect-nect-revoke",
    title: i18n.t("RevokePage.title"),
    components: {
        HeaderBig,
        HeaderMedium,
        CustomButton,
        BaseTimer,
    },
    props: ["signer_id"],
    data() {
        return {
            checked: false,
            success: false,
            certificate_id: '',
            resetPassword: false,
            password: '',
            confirmPassword: '',
            showConfirmPassword: false,
            rules: {
                passwordConfirmationRules: [
                    v => !!v || i18n.t('LoginRegisterPage.labels.required'),
                    v => this.password == v || i18n.t('equivalent_password')
                ],
                password: [
                    (v) => !!v || this.$t("required"),
                    (v) => (v && v.length >= 8) || this.$t("password_min_length"),
                    (v) => /(?=.*[A-Z])/.test(v) || this.$t("password_upper_case"),
                    (v) => /(?=.*[a-z])/.test(v) || this.$t("password_lower_case"),
                    (v) => /(?=.*\d)/.test(v) || this.$t("password_number"),
                    (v) => /([@$!%*?&])/.test(v) || this.$t("password_special_chars"),
                ],
            },
            showNewPassword: false
        };
    },
    created: async function () {
        this.color = this.$vuetify.theme.themes.light.primary;

        if (cookie.get("passwordReset")) {
            this.resetPassword = true;
        }

        if (cookie.get("certificate_id") === 'undefined' && !this.resetPassword) {
            this.redirect();
        }

        this.certificate_id = cookie.get("certificate_id")

        await this.$store
            .dispatch("data/checkNect", { uuid: cookie.get("nect-token"), revoke: true, signer_id: this.signer_id })
            .then((res) => {
                if (res.state == "complete") {
                    if (res.success) {
                        this.success = true;
                    } else {
                        this.success = false;
                    }
                }
            }).finally(() => {
                this.checked = true;
            });
    },
    methods: {
        async changePassword() {
            if (this.$refs.form.validate()) {
                await this.$store
                    .dispatch("data/getEmailById", {
                        signer_id: this.signer_id
                    })
                    .then((resp) => {
                        this.$store.dispatch("data/changePassword", {
                            email: resp,
                            password: this.password
                        })
                            .then(() => {
                                this.password = null;
                                this.confirmPassword = null;
                            })
                            .finally(() => {
                                cookie.remove('passwordReset')
                                cookie.remove('nect-token')
                                this.$router.push(
                                    "/revoke"
                                );
                            })
                            .catch((err) => {
                                log("RevokePage.RevokeTable.changePassword() - " + err, "error");
                            });
                    })
                    .catch((err) => {
                        phone = "";
                        log("RevokePage.RevokeTable.revoke() - " + err, "error");
                    });
            }
        },
        redirect() {
            localStorage.clear()
            sessionStorage.clear()
            this.$router.push(
                "/revoke"
            );
        },
        async next() {
            if (!cookie.get("certificate_id")) {
                await this.$router.push(
                    "/revoke"
                );
            }
            this.$store
                .dispatch("data/revokeCertificate", { cert_id: this.certificate_id, type: 'qes' })
                .then(() => {
                    this.$router.push(
                        "/revoke"
                    );
                })
                .catch((err) => {
                    this.otp = "";
                    log("RevokePage.index.revoke() - " + err, "error");
                });
        },
    },
};
</script>

<style>
.half-circle-spinner,
.half-circle-spinner * {
    box-sizing: border-box;
}

.half-circle-spinner {
    width: 60px;
    height: 60px;
    border-radius: 100%;
    position: relative;
}

.half-circle-spinner .circle {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 100%;
    border: calc(60px / 10) solid transparent;
}

.half-circle-spinner .circle.circle-1 {
    border-top-color: #1e6569;
    animation: half-circle-spinner-animation 1s infinite;
}

.half-circle-spinner .circle.circle-2 {
    border-bottom-color: #1e6569;
    animation: half-circle-spinner-animation 1s infinite alternate;
}

@keyframes half-circle-spinner-animation {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
